const initialState = {
    str: ''
}

const passportNumberRed = (state = initialState, action) => {
    switch(action.type){
        case 'PASSPORT_NUMBER' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default passportNumberRed